import { createRouter, createWebHistory } from "vue-router";

import home from "@/pages/home.vue";
import login from "@/pages/login/login.vue";
import findId from "@/pages/login/findId.vue";
import findPw from "@/pages/login/findPw.vue";
import signUp0 from "@/pages/signUp/signUp0.vue";
import signUp1 from "@/pages/signUp/signUp1.vue";
import signUp2 from "@/pages/signUp/signUp2.vue";
import signUp3 from "@/pages/signUp/signUp3.vue";
import signUpOk from "@/pages/signUp/signUpOk.vue";
import myClass from "@/pages/myClass.vue";
import myPage from "@/pages/myPage.vue";
import noticeList from "@/pages/learningSupport/noticeList.vue";
import noticeDetail from "@/pages/learningSupport/noticeDetail.vue";
import faq from "@/pages/learningSupport/faq.vue";
import step from "@/pages/enrolment/step.vue";
import newEnrolment from "@/pages/enrolment/newEnrolment.vue";
import newEnrolmentClass from "@/pages/enrolment/newEnrolmentClass.vue";
import check from "@/pages/enrolment/check.vue";
import classDetail from "@/pages/enrolment/classDetail.vue";
import checkDetail from "@/pages/enrolment/checkDetail.vue";
import classOk from "@/pages/enrolment/classOk.vue";
import classList from "@/pages/enrolment/classList.vue";
import classOkMobile from "@/pages/enrolment/classOkMobile.vue";
import adultEngPageAll from "@/pages/courseIntroduce/adultEng/pageAll.vue";
import adultEngPage1 from "@/pages/courseIntroduce/adultEng/page1.vue";
import adultEngPage2 from "@/pages/courseIntroduce/adultEng/page2.vue";
import adultEngPage3 from "@/pages/courseIntroduce/adultEng/page3.vue";
import adultEngPage4 from "@/pages/courseIntroduce/adultEng/page4.vue";
import adultEngPage5 from "@/pages/courseIntroduce/adultEng/page5.vue";
import adultEngPage6 from "@/pages/courseIntroduce/adultEng/page6.vue";
import adultChiPageAll from "@/pages/courseIntroduce/adultChi/pageAll.vue";
import adultChiPage1 from "@/pages/courseIntroduce/adultChi/page1.vue";
import adultChiPage2 from "@/pages/courseIntroduce/adultChi/page2.vue";
import adultChiPage3 from "@/pages/courseIntroduce/adultChi/page3.vue";
import adultChiPage4 from "@/pages/courseIntroduce/adultChi/page4.vue";
import adultChiPage5 from "@/pages/courseIntroduce/adultChi/page5.vue";
import adultJapPageAll from "@/pages/courseIntroduce/adultJap/pageAll.vue";
import adultJapPage1 from "@/pages/courseIntroduce/adultJap/page1.vue";
import adultJapPage2 from "@/pages/courseIntroduce/adultJap/page2.vue";
import adultJapPage3 from "@/pages/courseIntroduce/adultJap/page3.vue";
import adultJapPage4 from "@/pages/courseIntroduce/adultJap/page4.vue";
import adultEtc from "@/pages/courseIntroduce/adultEtc.vue";
import junior from "@/pages/courseIntroduce/junior.vue";
import korean from "@/pages/courseIntroduce/korean.vue";
import selfLearning from "@/pages/selfLearning.vue";
import questionPage from "@/pages/questionPage.vue";
import notFound from "@/pages/notFound.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: home,
    },
    {
      // 메인
      path: "/home",
      name: "home",
      component: home,
    },
    {
      // 로그인
      path: "/login/login",
      name: "login",
      component: login,
      meta: {
        title: "로그인",
      },
    },
    {
      // 아이디 찾기
      path: "/login/findId",
      name: "findId",
      component: findId,
      meta: {
        title: "아이디 찾기",
      },
    },
    {
      // 비밀번호 찾기
      path: "/login/findPw",
      name: "findPw",
      component: findPw,
      meta: {
        title: "비밀번호 찾기",
      },
    },
    {
      // 회원가입 - 유형 선택
      path: "/signUp/signUp0",
      name: "signUp0",
      component: signUp0,
      meta: {
        title: "회원가입",
      },
    },
    {
      // 회원가입 - 약관동의
      path: "/signUp/signUp1",
      name: "signUp1",
      component: signUp1,
      meta: {
        title: "회원가입",
      },
    },
    {
      // 회원가입 - 폼 입력
      path: "/signUp/signUp2",
      name: "signUp2",
      component: signUp2,
      meta: {
        title: "회원가입",
      },
    },
    {
      // 회원가입 - 폼 입력
      path: "/signUp/signUp3",
      name: "signUp3",
      component: signUp3,
      meta: {
        title: "회원가입",
      },
    },
    {
      // 회원가입 - 완료
      path: "/signUp/signUpOk",
      name: "signUpOk",
      component: signUpOk,
      meta: {
        title: "회원가입",
      },
    },
    {
      // 나의 학습방
      path: "/myClass",
      name: "myClass",
      component: myClass,
      meta: {
        title: "나의 학습방",
      },
    },
    {
      // 회원정보수정
      path: "/myPage",
      name: "myPage",
      component: myPage,
      meta: {
        title: "회원정보수정",
      },
    },
    {
      // 공지사항 - 리스트
      path: "/learningSupport/noticeList",
      name: "noticeList",
      component: noticeList,
      meta: {
        title: "공지사항",
      },
    },
    {
      // 공지사항 - 상세
      path: "/learningSupport/noticeDetail",
      name: "noticeDetail",
      component: noticeDetail,
      meta: {
        title: "공지사항",
      },
    },
    {
      // faq
      path: "/learningSupport/faq",
      name: "faq",
      component: faq,
      meta: {
        title: "FAQ",
      },
    },
    {
      // 수강절차 안내
      path: "/enrolment/step",
      name: "step",
      component: step,
      meta: {
        title: "수강절차 안내",
      },
    },
    // {
    //   // 수강신청 바로가기
    //   path: "/enrolment/goEnrolment",
    //   name: "goEnrolment",
    //   component: goEnrolment,
    //   meta: {
    //     title: "수강신청 바로가기",
    //   },
    // },
    {
      // 신규 신청
      path: "/enrolment/newEnrolment",
      name: "newEnrolment",
      component: newEnrolment,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 신규 신청 (처음부터 신청하기 페이지)
      path: "/enrolment/newEnrolmentClass",
      name: "newEnrolmentClass",
      component: newEnrolmentClass,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 신규 신청 이후 결제 안하고 이탈
      path: "/enrolment/check",
      name: "check",
      component: check,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 기존 수강 내역
      path: "/enrolment/classDetail",
      name: "classDetail",
      component: classDetail,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 신규 신청 이후 결제
      path: "/enrolment/checkDetail",
      name: "checkDetail",
      component: checkDetail,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 수강신청 완료 이후 (신청 내역, 결제 까지)
      path: "/enrolment/classOk",
      name: "classOk",
      component: classOk,
      meta: {
        title: "수강신청 바로가기",
      },
    },
    {
      // 수강신청 내역확인
      path: "/enrolment/classList",
      name: "classList",
      component: classList,
      meta: {
        title: "수강신청 내역확인",
      },
    },
    {
      // 수강신청 내역확인
      path: "/enrolment/classOkMobile",
      name: "classOkMobile",
      component: classOkMobile,
      meta: {
        title: "수강신청 결제확인",
      },
    },
    // {
    //   // 연간 과정일정
    //   path: "/courseIntroduce/yearly",
    //   name: "yearly",
    //   component: yearly,
    //   meta: {
    //     title: "연간 과정일정",
    //   },
    // },
    {
      // 성인 과정 (영어, 전체 커리큘럼 맵)
      path: "/courseIntroduce/adultEng/pageAll",
      name: "adultEngPageAll",
      component: adultEngPageAll,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - 일반회화
      path: "/courseIntroduce/adultEng/page1",
      name: "adultEngPage1",
      component: adultEngPage1,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - 비즈니스 회화
      path: "/courseIntroduce/adultEng/page2",
      name: "adultEngPage2",
      component: adultEngPage2,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - 토론회화
      path: "/courseIntroduce/adultEng/page3",
      name: "adultEngPage3",
      component: adultEngPage3,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - 시험,인터뷰대비
      path: "/courseIntroduce/adultEng/page4",
      name: "adultEngPage4",
      component: adultEngPage4,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - 로이터뉴스
      path: "/courseIntroduce/adultEng/page5",
      name: "adultEngPage5",
      component: adultEngPage5,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 영어 - globap topic
      path: "/courseIntroduce/adultEng/page6",
      name: "adultEngPage6",
      component: adultEngPage6,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 (중국어, 전체 커리큘럼 맵)
      path: "/courseIntroduce/adultChi/pageAll",
      name: "adultChiPageAll",
      component: adultChiPageAll,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 중국어 - 일반회화
      path: "/courseIntroduce/adultChi/page1",
      name: "adultChiPage1",
      component: adultChiPage1,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 중국어 - 비즈니스 회화
      path: "/courseIntroduce/adultChi/page2",
      name: "adultChiPage2",
      component: adultChiPage2,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 중국어 - 토론회화
      path: "/courseIntroduce/adultChi/page3",
      name: "adultChiPage3",
      component: adultChiPage3,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 중국어 - 시험대비과정
      path: "/courseIntroduce/adultChi/page4",
      name: "adultChiPage4",
      component: adultChiPage4,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 중국어 - 테마과정
      path: "/courseIntroduce/adultChi/page5",
      name: "adultChiPage5",
      component: adultChiPage5,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 (중국어, 전체 커리큘럼 맵)
      path: "/courseIntroduce/adultJap/pageAll",
      name: "adultJapPageAll",
      component: adultJapPageAll,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 일본어 - 일반회화
      path: "/courseIntroduce/adultJap/page1",
      name: "adultJapPage1",
      component: adultJapPage1,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 일본어 - 비즈니스 회화
      path: "/courseIntroduce/adultJap/page2",
      name: "adultJapPage2",
      component: adultJapPage2,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 일본어 - 토론회화
      path: "/courseIntroduce/adultJap/page3",
      name: "adultJapPage3",
      component: adultJapPage3,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 일본어 - 테마과정
      path: "/courseIntroduce/adultJap/page4",
      name: "adultJapPage4",
      component: adultJapPage4,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 성인 과정 - 제2 외국어
      path: "/courseIntroduce/adultEtc",
      name: "adultEtc",
      component: adultEtc,
      meta: {
        title: "성인 과정",
      },
    },
    {
      // 주니어 과정
      path: "/courseIntroduce/junior",
      name: "junior",
      component: junior,
      meta: {
        title: "주니어 과정",
      },
    },
    {
      // 한국어 과정 (195 남북하나재단 전용)
      path: "/courseIntroduce/korean",
      name: "korean",
      component: korean,
      meta: {
        title: "한국어 과정",
      },
    },
    {
      // 자기주도학습
      path: "/selfLearning",
      name: "selfLearning",
      component: selfLearning,
      meta: {
        title: "주니어 과정",
      },
    },
    {
      // 자기주도학습
      path: "/questionPage",
      name: "questionPage",
      component: questionPage,
      meta: {
        title: "주니어 과정",
      },
    },
    {
      // idx 없는 일반 경로 진입 시 이동하는 404 경로 (main.js 에서 사용)
      path: "/notFound",
      name: "notFound",
      component: notFound,
      meta: {
        title: "페이지를 찾을 수 없습니다",
        hideLayout: true,
      },
    },
    {
      // 매칭되지 않는 모든 경로 → 404 (catch-all, 항상 마지막)
      path: "/:pathMatch(.*)*",
      name: "notFoundCatchAll",
      component: notFound,
      meta: {
        title: "페이지를 찾을 수 없습니다",
        hideLayout: true,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: "smooth" };
  },
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   } else {
//     document.title = "평생교육";
//   }
//   next();
// });

export default router;
